














































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import { CopyUrl } from "@/common/clipboard";
import { ref, computed } from "@vue/composition-api";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
  },
  setup(props) {
    const showLoader = ref(false);
    const tableRow = ref(null);

    const onCountClick = () => {
      EventBus.emit("events", {
        item: props.source,
        // @ts-ignore
        rowEl: tableRow.value.$el,
      });
    };

    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showMenu", { item: props.source, event });

    const toolipData = computed(() => {
      // @ts-ignore
      const { exposedPersonCount, someExposedToRefs } = props.source.details;
      const res = [
        "Exposed to",
        ...someExposedToRefs.map((d: any) => d.emailAddress),
      ];
      const diff = exposedPersonCount - someExposedToRefs.length;
      if (diff > 0) {
        res.push(`and ${diff} more...`);
      }
      return res;
    });

    return {
      showLoader,
      tableRow,
      onCountClick,
      CopyUrl,
      showMenu,
      toolipData,
    };
  },
});
